import axios from 'axios';
import { NotificationManager } from 'react-notifications';

import config from '../../config';
import { history } from '../../store';

// axios.interceptors.request.use(function (config) {
//    const token = localStorage.getItem("userTokenTSYS");
//    config.headers.Authorization =  token;

//    return config;
// });
 

axios.interceptors.response.use(response => {
   return response;
}, error => {
  const status = error?.response?.status;

  if (status === 403) {
   NotificationManager.error('Oturmun süresi doldu yeniden giriş yapmanız gerekiyor.' )    
    localStorage.removeItem("userYaysis");
   localStorage.removeItem("userTokenTSYS");
   window.location.href =  config.mainPageUrl + `?status=false&message=Oturmunuzun süresi dolmuştur. Yeniden giriş yapınız.&code=403`;
   history.push("/says/403");
}
else if (status === 401) {
   NotificationManager.error('Yetkisiz erişim' )     
   history.push("/says/401");
}
else if (status) {
   history.push("/says/404");
}

  // API fonksiyonları response.data beklediği için tutarlı bir gövde dön
  return Promise.resolve({
    data: {
      status: false,
      data: null,
      message: error?.response?.data?.message || error?.message || 'İstek başarısız',
    },
  });
});



export const postUserOtherAuthCheck = async(user)=>{
   const token = localStorage.getItem("userTokenTSYS");
      const configAxios = {
         headers: { Authorization: "Bearer " + token }
      }

   const url = `${config.userCheckApiUrl}`;
   return await axios.post(url,user,configAxios)
   .then(response => response.data);
}
 

export const postCreateUserApi = async(user)=>{
   const token = localStorage.getItem("userTokenTSYS");
   const configAxios = {
      headers: { Authorization: "Bearer " + token }
   }

   const url = `${config.apiUrl}/v1/auth/signUp`;
   return await axios.post(url,user,configAxios)
   .then(response => response.data)
}
 